import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services/updateData';
import { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import logo from '../../../assets/images/logo.webp';
export const ResetPasswordPage = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { base_url } = useAppContext();
    const { token } = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (password !== confirmPassword) {
            if (window.showAlert) {
                window.showAlert(400, 'Passwords do not match');
            }
            setIsLoading(false);
            return;
        }

        if (password.length < 8) {
            if (window.showAlert) {
                window.showAlert(400, 'Password must be at least 8 characters long');
            }
            setIsLoading(false);
            return;
        }

        try {
            console.log('Resetting password with token:', token);
            const response = await updateData(token, `${base_url}/apis/admin/profile`, {
                token,
                password,
                confirm_password: confirmPassword
            });

            console.log(response);

            if (response && response.msg === 'User updated successfully') {
                if (window.showAlert) {
                    window.showAlert(200, 'Password has been successfully reset. You can now sign in with your new password.');
                }
                setTimeout(() => {
                    navigate('/');
                }, 3000);
            } else {
                if (window.showAlert) {
                    window.showAlert(400, response?.message || 'Failed to reset password. The reset link may be invalid or expired.');
                }
            }
        } catch (err) {
            if (window.showAlert) {
                window.showAlert(500, 'An error occurred. Please try again.');
            }
            console.error('Password reset error:', err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay auth-page">
            <div className="auth-page__header">
                <img
                    src={logo}
                    alt="Company Logo"
                    className="auth-page__logo"
                />
                <h1 className="auth-page__title">
                    Set New Password
                </h1>
                <p className="auth-page__subtitle">
                    Enter your new password below
                </p>
            </div>

            <div className="modal-content auth-page__card">
                <h2 className="modal-title">Reset Password</h2>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="password" className="form-label">
                            New Password
                        </label>
                        <div className="password-field">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                className="form-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="Enter your new password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="password-toggle"
                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                            >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmPassword" className="form-label">
                            Confirm New Password
                        </label>
                        <div className="password-field">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                id="confirmPassword"
                                className="form-input"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                placeholder="Confirm your new password"
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="password-toggle"
                                aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                            >
                                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                            </button>
                        </div>
                    </div>

                    <div className="password-requirements">
                        <strong>Password requirements:</strong>
                        <ul>
                            <li>At least 8 characters long</li>
                            <li>Use a combination of letters, numbers, and symbols</li>
                        </ul>
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="btn btn-primary btn--block"
                            disabled={isLoading}
                        >
                            {isLoading ? 'Resetting Password...' : 'Reset Password'}
                        </button>
                    </div>
                </form>

                <div className="auth-page__footer">
                    <p className="auth-page__footer-p">
                        Remember your password?{' '}
                        <Link to="/login" className="text-link">
                            Sign in here
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};
